if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.productInfo = this.closest("product-info");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        this.setupPackPicker();
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        const selectedPackQuantity = this.getSelectedPackQuantity();
        const submittedQuantity = Number.parseInt(formData.get("quantity"), 10);
        const baseQuantity =
          Number.isFinite(submittedQuantity) && submittedQuantity > 0
            ? submittedQuantity
            : 1;
        let finalQuantity = baseQuantity * selectedPackQuantity;

        const isEventItem = this.dataset.eventItem === "true";
        const productId = this.dataset.productId;

        if (!isEventItem && productId && window.QtyLimit) {
          try {
            const maxForProduct = QtyLimit.getMaxForProduct(
              this.dataset.maxPerProduct ||
                this.getQuantityLimitInput()?.dataset?.maxPerProduct,
            );
            const remaining = await QtyLimit.remainingAllowance(
              productId,
              maxForProduct,
            );
            const qtyInput = this.getQuantityLimitInput();
            if (remaining === 0) {
              this.handleErrorMessage();
              if (qtyInput) {
                QtyLimit.showTooltip(
                  qtyInput,
                  `You already have the maximum of ${maxForProduct} bottles of this wine in your cart.`,
                );
              }
              this.submitButton.classList.remove("loading");
              this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading__spinner").classList.add("hidden");
              return;
            }
            if (finalQuantity > remaining) {
              finalQuantity = remaining;
              const limitMessage = `You can add ${remaining} more (max ${maxForProduct} of this item).`;
              if (qtyInput) {
                QtyLimit.showTooltip(qtyInput, limitMessage);
              }
            }
          } catch (e) {
            console.error(e);
          }
        }

        formData.set("quantity", String(finalQuantity));
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker(
              "add:wait-for-subscribers",
            );
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  "add:wait-for-subscribers",
                  startMarker,
                );
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      () => {
                        this.cart.renderContents(response);
                      },
                    );
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      setupPackPicker() {
        if (!this.productInfo) return;

        this.packPicker = this.productInfo.querySelector(
          `[data-pack-picker][data-section-id="${this.dataset.sectionId}"]`,
        );
        if (!this.packPicker) return;

        this.packQuantityInput = this.packPicker.querySelector(
          "[data-pack-quantity-input]",
        );
        this.packOptions = Array.from(
          this.packPicker.querySelectorAll("[data-pack-quantity]"),
        );
        if (!this.packOptions.length) return;

        this.packPicker.addEventListener("click", (event) => {
          const selectedOption = event.target.closest("[data-pack-quantity]");
          if (!selectedOption) return;
          this.setSelectedPackOption(selectedOption);
        });

        const defaultOption =
          this.packOptions.find((option) =>
            option.classList.contains("is-selected"),
          ) || this.packOptions[0];
        this.setSelectedPackOption(defaultOption);
      }

      setSelectedPackOption(selectedOption) {
        if (!this.packOptions?.length || !selectedOption) return;

        this.packOptions.forEach((option) => {
          const isSelected = option === selectedOption;
          option.classList.toggle("is-selected", isSelected);
          option.setAttribute("aria-pressed", isSelected ? "true" : "false");
        });

        if (this.packQuantityInput) {
          this.packQuantityInput.value =
            selectedOption.dataset.packQuantity || "1";
        }

        this.setPackOptionMedia(selectedOption);
      }

      setPackOptionMedia(selectedOption) {
        if (!selectedOption || !this.productInfo) return;

        const packMediaId = selectedOption.dataset.packMediaId;
        const sectionId =
          this.dataset.sectionId || this.productInfo.dataset.section;
        const mediaGallery = this.productInfo.querySelector("media-gallery");
        if (!packMediaId || !sectionId || !mediaGallery?.setActiveMedia) return;

        mediaGallery.setActiveMedia(`${sectionId}-${packMediaId}`, false);
      }

      getSelectedPackQuantity() {
        if (!this.packOptions?.length) return 1;

        const selectedOption = this.packOptions.find((option) =>
          option.classList.contains("is-selected"),
        );
        const selectedQuantity =
          selectedOption?.dataset.packQuantity ||
          this.packQuantityInput?.value ||
          this.packOptions[0]?.dataset.packQuantity;
        const parsedQuantity = Number.parseInt(selectedQuantity, 10);
        return Number.isFinite(parsedQuantity) && parsedQuantity > 0
          ? parsedQuantity
          : 1;
      }

      getQuantityLimitInput() {
        return (
          this.productInfo?.querySelector(
            'input[name="quantity"][data-max-per-product]',
          ) ||
          document.getElementById(`Quantity-${this.dataset.sectionId}`) ||
          this.form.querySelector(
            ".quick-add-card__qty-input[data-max-per-product]",
          )
        );
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
}
